export default {
  提现中: 'Withdrawing',
  奖励编号: 'Reward Code',
  奖励邀请: 'Invitation Rewards',
  被邀请人注册账号: 'Account of the Invitee',
  被邀请人注册日期: 'Registration Date of the Invitee',
  完成任务时间: 'Time',
  注册时间: 'Time of Registration',
  奖励金币: 'Gold Coins',
  奖励状态: 'Status',
  累计已获奖励金: 'Accumulated Rewards',
  去充值: 'to recharge',
  去提现: 'to withdraw',
  生成链接: 'Creating Link',
  生成海报: 'Creating Poster',
  保存海报: 'Save Poster',
  分享给你啦: 'Successfully Shared',
  我的奖励明细: 'My Reward',
  '邀请注册成功(任务进行中)': 'Invitation to register successfully (task in progress)',
  任务失败: 'task failed',
  '红包最高 1000 元': 'Maximum rewards are ¥1,000',
  立即分享给好友可获: 'Get it by sharing to your friends',
  系统自动发送: 'Sent by the system automatically',
  '有效期14天,逾期未提现将失效': 'The reward would be effective for 14 days. Expired rewards will  be invalid',
  活动说明: 'Event Description',
  活动奖励: 'Activity Award',
  邀新活动1:
    'If you successfully invite a new user to register the Cloud Momentum APP, you will be rewarded with gold coins.',
  邀新活动2:
    'Share the activity page to your Wechat friends or Moments (Details provided by us shall prevail). If new users register  through the links or posters you shared, your invitations are considered successful.',
  邀新活动3:
    'You can also share your invite code (Cloud Momentum-My Account-My Invitation) to your friends.  If he/she signs up  and entering your invite code, the referral is successful.',
  邀新活动4: 'Every invite code can only be used to invite friends.',
  邀新活动5:
    'The Gold Coins from inviting new users are activity rewards which are valid for 90 days from date issued. Please consume or withdraw the Gold Coins within the effective period.',
  邀新活动6:
    'You are only eligible for one invitation reward per individual. The same login account, phone number, device and withdrawal account are regarded as a same user.',
  邀新活动7:
    'You can apply for withdrawing the rewards when the Gold Coins in your account reach the withdrawal limit. Withdrawal funds usually arrive into your bank account within 3-5 working days. If it’s on holidays or at the peak time of withdrawal, please forgive that the time may be extended.',
  邀新活动8:
    'Please understand that some mobile phone numbers or number segments are not within the scope of this event.',
  邀新活动9:
    'You may not participate this promotion activity in an improper way, including but not limited to register with an unlisted or ineffective phone number, infringe or even steal others’  rights and interests, cheat, disrupt the system or take action to compromise the security of this site. To those who take above actions, we are entitled to reject the applications, reclaim the previous rewards, and reserve the right to take any other actions and pursue any other legal rights available.',
  邀新活动10: 'The maximum rewards are 1,000 coins per individual.',
  邀新活动11: 'Cloud Momentum reserves the right, at its sole discretion, to interpret these Terms of Use.',
}
